/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IUtilityInfo } from '../../components/UtilityServiceSettings/IUtilityServiceSettingsProps';

class UtilityAccountActions {
  static SHOW_MODAL = 'SHOW_MODAL';
  static SHOW_CREDENTIAL_MODAL = 'SHOW_CREDENTIAL_MODAL';
  static SET_SELECTED_UTILITY_INFO: 'SET_SELECTED_UTILITY_INFO';
  static SHOW_DEACTIVATE_ACCOUNT_MODAL = 'SHOW_DEACTIVATE_ACCOUNT_MODAL';
  static SHOW_DEACTIVATE_IDS_MODAL = 'SHOW_DEACTIVATE_IDS_MODAL';
  static SHOW_REACTIVATE_ACCOUNT_MODAL = 'SHOW_REACTIVATE_ACCOUNT_MODAL';
  static SHOW_REACTIVATE_IDS_MODAL = 'SHOW_REACTIVATE_IDS_MODAL';
  static SHOW_REVERIFY_MODAL = 'SHOW_REVERIFY_MODAL';
  static SHOW_METER_NAME_CHANGE_MODAL = 'SHOW_METER_NAME_CHANGE_MODAL';
  static SHOW_CONVERSION_MODAL = 'SHOW_CONVERSION_MODAL';
  static EDIT_DETAILS = 'EDIT_DETAILS';
  static SHOW_ENABLE_IDS_MODAL = 'SHOW_ENABLE_IDS_MODAL';
  static showMeterNameChangeModal = () => {
    return {
      type: UtilityAccountActions.SHOW_METER_NAME_CHANGE_MODAL,
      payload: true
    };
  };
  static hideProviderModal = () => {
    return {
      type: UtilityAccountActions.SHOW_METER_NAME_CHANGE_MODAL,
      payload: false
    };
  };
  static showUtilityModal = () => {
    return {
      type: UtilityAccountActions.SHOW_MODAL,
      payload: true
    };
  };

  static hideUtilityModal = () => {
    return {
      type: UtilityAccountActions.SHOW_MODAL,
      payload: false
    };
  };

  static setSelectedUtilityInfo = (utilityInfo: IUtilityInfo) => {
    return {
      type: UtilityAccountActions.SET_SELECTED_UTILITY_INFO,
      payload: utilityInfo
    };
  };
  static resetSelectedUtilityInfo = () => {
    return {
      type: UtilityAccountActions.SET_SELECTED_UTILITY_INFO,
      payload: {} as IUtilityInfo
    };
  };

  static showDeactivateAccountModal = () => {
    return {
      type: UtilityAccountActions.SHOW_DEACTIVATE_ACCOUNT_MODAL,
      payload: true
    };
  };
  static showDeactivateIDSModal = () => {
    return {
      type: UtilityAccountActions.SHOW_DEACTIVATE_IDS_MODAL,
      payload: true
    };
  };
  static showReactivateAccountModal = () => {
    return {
      type: UtilityAccountActions.SHOW_REACTIVATE_ACCOUNT_MODAL,
      payload: true
    };
  };
  static showReactivateIDSModal = () => {
    return {
      type: UtilityAccountActions.SHOW_REACTIVATE_IDS_MODAL,
      payload: true
    };
  };
  static hideDeactivateAccountModal = () => {
    return {
      type: UtilityAccountActions.SHOW_DEACTIVATE_ACCOUNT_MODAL,
      payload: false
    };
  };

  static hideDeactivateIDSModal = () => {
    return {
      type: UtilityAccountActions.SHOW_DEACTIVATE_IDS_MODAL,
      payload: false
    };
  };

  static hideReactivateAccountModal = () => {
    return {
      type: UtilityAccountActions.SHOW_REACTIVATE_ACCOUNT_MODAL,
      payload: false
    };
  };
  static hideReactivateIDSModal = () => {
    return {
      type: UtilityAccountActions.SHOW_REACTIVATE_IDS_MODAL,
      payload: false
    };
  };

  static showReverifyModal = () => {
    return {
      type: UtilityAccountActions.SHOW_REVERIFY_MODAL,
      payload: true
    };
  };
  static hideReverifyModal = () => {
    return {
      type: UtilityAccountActions.SHOW_REVERIFY_MODAL,
      payload: false
    };
  };
  static showConversionModal = () => {
    return {
      type: UtilityAccountActions.SHOW_CONVERSION_MODAL,
      payload: true
    };
  };
  static editDetailsModal = (payloadVal: any) => {
    return {
      type: UtilityAccountActions.EDIT_DETAILS,
      payload: true,
      valueDetails: payloadVal
    };
  };
  static hideeditDetailsModal = () => {
    return {
      type: UtilityAccountActions.EDIT_DETAILS,
      payload: false
    };
  };
  static hideConversionModal = () => {
    return {
      type: UtilityAccountActions.SHOW_CONVERSION_MODAL,
      payload: false
    };
  };
  static showEnableIDSModal = () => {
    return {
      type: UtilityAccountActions.SHOW_ENABLE_IDS_MODAL,
      payload: true
    };
  };
  static hideEnableIDSModal = () => {
    return {
      type: UtilityAccountActions.SHOW_ENABLE_IDS_MODAL,
      payload: false
    };
  };
}

export default UtilityAccountActions;
